module.exports = __webpack_public_path__ + "img/gear.a90fe4dd.svg";